import React from "react";
import { Discuss, Oval } from "react-loader-spinner";

function ResponseLoader() {
  return (
    <div className="data-loader">
      <Discuss
        visible={true}
        height="20"
        width="20"
        ariaLabel="discuss-loading"
        wrapperStyle={{}}
        wrapperClass="discuss-wrapper"
        colors={["var(--color-1)", "var(--color-1)"]}
      />
    </div>
  );
}

export function DataLoader() {
  return (
    <div className="data-loader">
      <Oval
        visible={true}
        height="40"
        width="40"
        ariaLabel="discuss-loading"
        wrapperStyle={{}}
        wrapperClass="discuss-wrapper"
        color="var(--color-1)"
      />
    </div>
  );
}

export default ResponseLoader;
